import { tokenBlacklistService } from './tokenSecurity';
import { cacheControl } from '../middleware/cacheControl';

export const cacheUtils = {
  withCache: (url, options = {}) => {
    return fetch(url, {
      ...options,
      headers: {
        'Cache-Control': 'public, max-age=300',
        ...options.headers
      }
    });
  },

  withoutCache: (url, options = {}) => {
    return fetch(url, {
      ...options,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        ...options.headers
      }
    });
  },

  // Secure fetch for authentication endpoints
  secureAuthFetch: (url, options = {}) => {
    const token = sessionStorage.getItem('Token');
    
    if (token && tokenBlacklistService.isBlacklisted(token)) {
      return Promise.reject(new Error('Token has been invalidated'));
    }
    
    return fetch(url, {
      ...options,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate, private',
        'Pragma': 'no-cache',
        'Expires': '0',
        'X-Content-Type-Options': 'nosniff',
        'X-Frame-Options': 'DENY',
        'Authorization': token ? `Bearer ${token}` : '',
        ...options.headers
      }
    });
  },

  // Long cache for static resources
  staticResourceFetch: (url, options = {}) => {
    return fetch(url, {
      ...options,
      headers: {
        'Cache-Control': 'public, max-age=31536000',
        ...options.headers
      }
    });
  },

  clearAuthCache: () => {
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          if (name.includes('auth') || name.includes('token')) {
            caches.delete(name);
          }
        });
      });
    }
    
    sessionStorage.clear();
    
    ['accessToken', 'refreshToken', 'userToken'].forEach(key => {
      localStorage.removeItem(key);
    });
  },

  isCached: (response) => {
    return response.headers.get('cache-control')?.includes('max-age');
  }
};